/* eslint-disable */
// Src: https://bulma.io/documentation/components/navbar/
const $ = require('jquery');

const toggleClassName = function () {
	$('.js-toggle-class').click(function (e) {
		// Toggle the "is-active" class on both the selector and itself
		const selector = $(this).data('toggle-selector');
		const classname = $(this).data('toggle-classname');
		const notSelf = $(this).data('toggle-not-self');
		//console.log(selector, classname, notSelf,$(selector));
		let el = $(this);
		if (notSelf) {
			el = $(selector);
		}

		el.toggleClass(classname);
		if (el.hasClass(classname) && $(this).hasClass('js-focus')) {
			el.find('input').focus();
		}
	});

	$('.js-alternate-address').change(function(){
		$('.js-div-toshow-billing').toggleClass('is-hidden', $(this).prop('checked') != true)
	});
	$('.js-toggle-shipping').change(function(){
		$('.js-setActive').removeClass('is-active');
		$(this).closest('.js-setActive').addClass('is-active');
		$('.js-show-shipping-items').toggleClass('is-hidden', $(this).val() == 'retrieve')
		$('.js-hide-shipping-items').toggleClass('is-hidden', $(this).val() != 'retrieve')
	})
	$('.js-alternate-address').change();
	$('.js-toggle-shipping:checked').change();
};

module.exports = toggleClassName;
